<template>
  <div class="w-full">
    <Label v-if="label" :for="id" :required="true">{{ label }}</Label>
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 relative w-full">
      <svgicon name="search" size="sm" class="absolute left-2 top-2" />
    </div>
    <input
      :id="id"
      type="text"
      class="inline-flex h-8 items-center rounded-md border border-gray-300 bg-white py-0 pl-8 text-sm font-medium leading-8 text-gray-700 placeholder-gray-400 transition-colors duration-150 ease-in-out hover:bg-gray-50 disabled:cursor-default disabled:bg-gray-100 disabled:text-gray-400 w-full"
      :name="name"
      :placeholder="placeholder"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import Label from "~/components/inputs/Label";

export default {
  components: { Label },

  props: {
    label: String,

    id: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },
  },
};
</script>
